export default __webpack_public_path__ + "static/media/rotted_curtains1.cb627ac2.png";